import './App.css';
import FinisherHeader from './Components/header/Header';
import About from './Components/about/About';
import Ourservices from './Components/ourservice/Ourservices';
import Whtchoose from './Components/whychoose/Whtchoose';
import WaveFooter from './Components/footer/Footer';
import Contact from './Components/contact/Contact';
import Aboutus from "./Components/aboutmanin/Aboutmain";
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import Mainservicespage from './Components/mainservicepage/Mainservicespage';
import Development from './Components/development/Development';
import Logo from './Components/logo/Logo';
import Digital from './Components/digitalmarketing/Digital';
import Socailmedia from './Components/socialmedia/Socailmedia';
import Invitation from './Components/inivitation/Inivitation';
import FinisherHeaderComponent from './Components/animationservicepage/Animationservicepage';
import SEO from './Components/seo/SEO';
import Formpage from './Components/Formpage/Formpage';
import Servicepage from './Components/Servicepage/Servicepage';
import Web from './Components/web/Web';
import Branding from './Components/branding/Branding';
import Oursrvicesnew from './Components/ourservicesnew/Oursrvicesnew';
import Project from "./Components/Project/Project";
import Ourclient from "./Components/our-client/Ourclient";
import Testimonial from "./Components/testimonial/Testimonial";


import { useEffect } from 'react';
import Newabout from './Components/newabout/Newabout';
import Header from './Components/newheader/NewHeader';
import Navbar from './Components/navbar/Navbar';
import Thankspage from './Components/thankyoupage/Thankspage';

import Servicepage1 from "./Components/servicesnew/Servicepage";
import ScrollToTop from './Components/ScroolTop';



function AppWrapper() {
  const location = useLocation();

  return (
    <>
       <ScrollToTop />
      <Routes>
      
        <Route path="/" element={
          <>
            {/* <FinisherHeader /> */}
            <Navbar/>
            <Header/>
         
      

            <Newabout/>  
            {/* <About /> */}
            <Oursrvicesnew />
            <Project/>
            <Ourclient/>
            <Whtchoose />
            <Testimonial/>
            <Formpage />
          </>
        } />

        <Route path="/contact" element={<Contact />} />
        <Route path="/aboutmain" element={<Aboutus />} />
        <Route path="/web" element={<Development />} />
        <Route path="/logo" element={<Logo />} />
        <Route path="/digital" element={<Digital />} />
        <Route path="/socialmedia" element={<Socailmedia />} />
        <Route path="/Invitation" element={<Invitation />} />
        <Route path="/seo" element={<SEO />} />
        <Route path="/servicepage" element={<Servicepage1 />} />
        <Route path="/webdev" element={<Web />} />
        <Route path="/branding" element={<Branding />} />
        <Route path="/ourservicesnew" element={<Oursrvicesnew />} />
        <Route path = "/thankyou" element = {<Thankspage/>}/>
      </Routes>

      {/* Show footer unless on branding page */}
      {location.pathname !== '/branding' && <WaveFooter />}
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppWrapper />
    </BrowserRouter>
  );
}

export default App;
